export default [
    {
      path: '/admin/driver/transfers',
      name: 'transfer',
      meta: { requiresAuth: true },
      component: () => import('@/pages/driver/transfer/index.vue')
    }
  ]
